<template>
    <b-modal id="addNewChild" ref="addChildModal" hide-footer>
        <h1 class="text-center">Kind anmelden</h1>
        <h5 class="text-center mb-50">Hier kannst du ein weiteres Kind für den McDonald’s Junior Club anmelden.</h5>
        <div class="mandatory-note text-center">
            <p>* Pflichtfelder bitte ausfüllen</p>
        </div>
        <form>
            <div class="form-row" v-if="form.error1">
                <div class="form-group col-6 mb-0">
                    <div class="alert alert-danger">
                        {{ form.error1 }}
                    </div>
                </div>
            </div>
            <div class="form-row" v-if="form.error2">
                <div class="form-group col-6 mb-0">
                    <div class="alert alert-danger">
                        {{ form.error2 }}
                    </div>
                </div>
            </div>
            <div class="form-row" v-if="form.error3">
                <div class="form-group col-6 mb-0">
                    <div class="alert alert-danger">
                        {{ form.error3 }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group floating-label hide">
                    <input type="text" class="form-control" placeholder="E-Mail"
                           :value="this.$store.state.profileData.parentEmail" disabled="disabled">
                </div>
            </div>
<!--            <div class="form-row">-->
<!--                <div class="form-group col-12">-->
<!--                    <label class="standalone">Anrede *</label>-->
<!--                    <span v-if="errors.has('salutation')" class='invalid-feedback'>Bitte Anrede auswählen!</span>-->
<!--                    <b-form-radio name="salutation" value="MRS" v-model="form.salutation">Mädchen</b-form-radio>-->
<!--                    <b-form-radio name="salutation" v-validate="'required'" value="MR" v-model="form.salutation">-->
<!--                        Junge-->
<!--                    </b-form-radio>-->
<!--                </div>-->
<!--            </div>-->
            <div class="form-row mb-30">
                <div class="form-group floating-label col-12">
                    <span v-if="valid('firstname')" class='invalid-feedback'>Bitte Vornamen eingeben!</span>
                    <input v-validate="'required'"
                           type="text"
                           name="firstname"
                           class="form-control"
                           placeholder='Vorname'
                           v-model.trim="form.firstname"/>
                    <label>Vorname des Kindes *</label>
                </div>
                <div class="form-group floating-label col-12">
                    <span v-if="valid('lastname')" class='invalid-feedback'>Bitte Nachnamen eingeben!</span>
                    <input type="text"
                           name="lastname"
                           class="form-control"
                           v-validate="'required'"
                           placeholder='Nachname' v-model.trim="form.lastname">
                    <label>Nachname des Kindes *</label>
                </div>
            </div>
            <div class="form-row">

                <div class="form-group col-6">
                    <label class="standalone">Geburtsmonat *</label>
                    <div v-if="errors.first('month')" class='invalid-feedback'>Bitte Monat auswählen!</div>
                    <b-form-select v-validate="'required'"
                                   name="month"
                                   v-model="form.birthdayMM"
                                   class="mb-0">
                        <option :value="null">Bitte auswählen</option>
                        <option value="01">Januar</option>
                        <option value="02">Februar</option>
                        <option value="03">März</option>
                        <option value="04">April</option>
                        <option value="05">Mai</option>
                        <option value="06">Juni</option>
                        <option value="07">Juli</option>
                        <option value="08">August</option>
                        <option value="09">September</option>
                        <option value="10">Oktober</option>
                        <option value="11">November</option>
                        <option value="12">Dezember</option>
                    </b-form-select>
                </div>

                <div class="form-group col-6">
                    <label class="standalone">Geburtsjahr *</label>
                    <div v-if="errors.first('year')" class='invalid-feedback'>Bitte Jahr auswählen!</div>
                    <b-form-select v-validate="'required'"
                                   name="year"
                                   v-model="form.birthdayYYYY"
                                   :options="birthdayYYYYOptions"
                                   class="mb-0"/>
                </div>

            </div>
            <div class="form-row mb-30">
                <div class="form-group floating-label col-12">
                    <input type="text" class="form-control" placeholder="Mitgliedsnr. Kind"
                           v-model="form.membershipNumber">
                    <label>Mitgliedsnummer des Kindes</label>
                </div>
            </div>
        </form>
        <footer class="modal-footer yes-no">
            <button type="button" class="btn btn-link" @click="hideModal">Abbrechen</button>
            <button type="button"
                    class="btn btn-primary"
                    :disabled="!completed"
                    @click="addChild">Speichern
            </button>
        </footer>
    </b-modal>
</template>
<script>
    import {apiAddChild} from '../utils/api';

    export default {
        name: 'profileDataAddChildComponent',
        data() {
            return {
                profileDataAddChildResponse: [],
                birthdayYYYYOptions: this.getYears(),
                error1: '',
                error2: '',
                error3: '',
                form: {
                    // salutation: '',
                    firstname: '',
                    membershipNumber: '',
                    lastname: '',
                    birthdayYYYY: '',
                    birthdayMM: '',
                }
            };
        },
        computed: {
            completed() {
                return Object.keys(this.fields).every(key => this.fields[key].validated) && Object.keys(this.fields).every(key => this.fields[key].valid)
            }
        },
        methods: {

            valid(name) {
                return this.fields[name] && this.fields[name].touched && !this.fields[name].valid
            },

            hideModal() {
                this.$refs.addChildModal.hide();
            },
            getYears: function (param) {
                let thisYear = new Date().getFullYear();
                let year = thisYear - 14;
                if (param)
                    return year;

                let options = [];
                options.push({value: null, text: 'Bitte auswählen'});
                while (year <= thisYear) {
                    options.push({value: year, text: year});
                    year++;
                }
                return options;
            },
            addChild: function (e) {
                e.preventDefault();

                let childProperties = {
                    // 'salutation': this.form.salutation,
                    'firstname': this.form.firstname,
                    'lastname': this.form.lastname,
                    'birthMonth': this.form.birthdayMM,
                    'birthYear': this.form.birthdayYYYY.toString()
                };

                if (this.form.membershipNumber.length > 1)
                    childProperties.membershipNumber = this.form.membershipNumber
                else
                    childProperties.membershipNumber = null;

                apiAddChild({
                    'email': this.$store.state.profileData.parentEmail,
                    'child': childProperties
                })
                    .then(response => {

                        if (response.data.code === 0) {
                            this.$toasted.success('Das Kind wurde erfolgreich angemeldet', {
                                duration: 3000,
                                position: 'bottom-right'
                            });

                            this.$store.commit('updateProfileAddChild', childProperties);

                            this.$nextTick(() => {

                                // this.form.salutation = '';
                                this.form.firstname = '';
                                this.form.lastname = '';
                                this.form.birthdayMM = '';
                                this.form.birthdayYYYY = '';

                                this.$emit('addedChild');

                                this.hideModal();
                            });
                        } else if (response.data.code === 1)
                            this.$toasted.error('E-Mail-Adresse unbekannt', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else if (response.data.code === 2)
                            this.$toasted.error('Daten des Kindes nicht in Ordnung', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else if (response.data.code === 3)
                            this.$toasted.error('Mitgliedsnummer nicht bekannt', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else if (response.data.code === 4)
                            this.$toasted.error('Mitgliedsnummer bereits zugeordnet', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else if (response.data.code === 5)
                            this.$toasted.error('Sie können maximal fünf Kinder anmelden', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else if (response.data.code === 6)
                            this.$toasted.error('Du hast dieses Kind bereits angegeben', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else if (response.data.code === 99)
                            this.$toasted.error('Pflichtfeld nicht ausgefüllt', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else
                            this.$toasted.error(response.data.message, {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                    })
                    .catch(e => {
                        this.$store.commit('error', e);
                    });


            }
        }
    };
</script>
